import { useEffect, useState } from "react";
import { navLinks, brandName } from "@/mocks/gossip";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goAnchor = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setOpen(false);
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 md:px-6">
        <a
          href="#top"
          onClick={(e) => goAnchor(e, "#top")}
          className="flex items-center gap-2 py-4"
          aria-label={`${brandName} 首页`}
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
            <i className="ri-water-flash-line" aria-hidden="true" />
          </span>
          <span className="text-lg font-extrabold tracking-tight text-foreground-950">
            吃瓜<span className="text-primary-500">m</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <a
              key={l.key}
              href={l.href}
              onClick={(e) => goAnchor(e, l.href)}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-accent-100 hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="#feed"
            onClick={(e) => goAnchor(e, "#feed")}
            className="hidden whitespace-nowrap items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-video-add-line text-base" aria-hidden="true" />
            一起去围观
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full bg-background-100 text-foreground-800 lg:hidden"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50/95 px-4 pb-4 backdrop-blur-md lg:hidden">
          <div className="flex flex-col gap-1 pt-2">
            {navLinks.map((l) => (
              <a
                key={l.key}
                href={l.href}
                onClick={(e) => goAnchor(e, l.href)}
                className="rounded-xl px-3 py-2.5 text-base font-medium text-foreground-800 transition-colors hover:bg-accent-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#feed"
              onClick={(e) => goAnchor(e, "#feed")}
              className="mt-2 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-xl bg-primary-500 px-4 py-2.5 text-base font-semibold text-background-50"
            >
              <i className="ri-video-add-line text-lg" aria-hidden="true" />
              一起去围观
            </a>
          </div>
        </div>
      )}
    </header>
  );
}